(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var trustpilotDesktop = document.querySelector('.announcement-bar__trustpilot-desktop');
    if (trustpilotDesktop) {
      setTimeout(function() {
        trustpilotDesktop.classList.remove('hidden-opacity');
      }, 2000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('accordion-wrapper')) {
    customElements.define('accordion-wrapper', class Accordion extends HTMLElement {
      constructor() {
        super();

        this.listeners();
      }

      listeners() {
        let accordions = document.querySelectorAll('accordion-wrapper');

        accordions.forEach((el) => {
          const accordionHeaders = el.querySelectorAll('.accordion__header');
          const openFirstItem = el.getAttribute('data-open-first') === 'true';

          if (openFirstItem === true) {
            const firstItem = el.querySelector('.accordion__item');

            firstItem.classList.add('accordion__item--open');
          }

          accordionHeaders.forEach(el => el.addEventListener('click', this.accordionClickEvent));
        });
      }

      accordionClickEvent() {
        const accordionItem = this.closest('.accordion__item');
        const accordionContainer = this.closest('accordion-wrapper');
        const mobileOnly = accordionContainer.getAttribute('data-mobile-only') === 'true';
        const touchOnly = accordionContainer.getAttribute('data-touch-only') === 'true';

        const mediaQuery = window.matchMedia('(max-width: 989px)');

        if (mobileOnly || touchOnly) {
          if (mediaQuery.matches) Accordion.toggleStates(accordionContainer, accordionItem);
        } else {
          Accordion.toggleStates(accordionContainer, accordionItem);
        }
      }

      // Toggle active states of clicked accordion
      static toggleStates(container, item) {
        const wrapper = container.closest('.js-accordion-container');
        const parent = container.parentNode;
        const accordionItems = (wrapper || parent).querySelectorAll('.accordion__item:not(.accordion__item--disabled)');
        const autoClose = container.getAttribute('data-auto-close') === 'true';

        let isDelay = false;

        if (!item.classList.contains('accordion__item--open')) {
          if (autoClose === true) {
            accordionItems.forEach(el => {
              if (el.classList.contains('accordion__item--open')) {
                this.closeAccordion(el);

                isDelay = true;
              }
            });
          }

          // Duration of animation
          setTimeout(() => this.openAccordion(item), isDelay ? 250 : 0);
        } else {
          this.closeAccordion(item);
        }
      }

      static openAccordion(el, openFirst) {
        el.classList.add('accordion__item--open');

        const content = el.querySelector('.accordion__content');

        // Set properties to calculate height whilst hiding element
        content.style.width = `${content.offsetWidth}px`;
        content.style.position = 'absolute';
        content.style.visibility = 'hidden';
        content.style.height = 'auto';

        const height = `${content.offsetHeight}px`;

        // Reset properties used above to calculate height
        content.style.width = null;
        content.style.position = null;
        content.style.visibility = null;
        content.style.height = "0";

        // Wait for the "height: 0" style to be committed by the browser before
        // animating to the target height, without forcing a synchronous layout.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => content.style.height = height);
        });

        content.addEventListener('transitionend', () => {
          if (el.classList.contains('accordion__item--open')) content.style.height = 'auto';
        });
      }

      static repositionViewport(el) {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const offset = document.documentElement.scrollTop;
        const target = el.getBoundingClientRect().top;
        const header = document.documentElement.style.getPropertyValue('--header-height');

        let stickyHeader = 0

        if (!isMobile) stickyHeader = document.querySelector('.sticky-bag').getBoundingClientRect().top;

        const y = target + offset - header.replace('px', '') - stickyHeader;

        requestAnimationFrame(() => window.scrollTo({ top: y , behavior: 'smooth' }));
      }

      static closeAccordion(el) {
        el.classList.remove('accordion__item--open');

        const content = el.querySelector('.accordion__content');

        content.style.height = `${content.offsetHeight}px`;

        // Wait for the explicit height to be committed by the browser before
        // collapsing it, without forcing a synchronous layout.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => content.style.height = "0");
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"]) return;
  try {
    
  if (!customElements.get('product-info')) {
    customElements.define('product-info', class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios')
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1
        }

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    });
  }

  // subscribe/publish/PUB_SUB_EVENTS/debounce/pauseAllMedia are all read
  // from plain global <script src> tags (pubsub.js, constants.js,
  // global.js) - none of those are moved into a javascript block, so
  // they remain genuine globals this closure can safely read.
  if (!customElements.get('product-modal')) {
    customElements.define(
      "product-modal",
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove("active");
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
          const activeMediaTemplate = activeMedia.querySelector("template");
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add("active");

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent && activeMediaContent.querySelector(".js-youtube")) activeMedia.loadContent();
        }
      }
    );
  }

  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        }
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({behavior: 'smooth'});
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position
          );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    });
  }

  if (!customElements.get('product-model')) {
    customElements.define('product-model', class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }
    });
  }

  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },

    setupShopifyXR(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
          this.setupShopifyXR()
        );
        return;
      }

      document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
        modelJSON.remove();
      });
      window.ShopifyXR.setupXRElements();
    },
  };

  window.addEventListener('DOMContentLoaded', () => {
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
  });

  // Fixes a pre-existing bug: this was previously an undeclared assignment
  // (`overlay = ...`), which happened to work as an accidental global in a
  // plain script but would throw in the strict-mode closure this tag wraps
  // content in. Declared properly here, shared between createOverlay() and
  // moveWithHover() exactly as before.
  let overlay;

  function createOverlay(image) {
    const overlayImage = document.createElement('img');
    overlayImage.setAttribute('src', `${image.src}`);
    overlay = document.createElement('div');
    prepareOverlay(overlay, overlayImage);

    image.style.opacity = '50%';
    toggleLoadingSpinner(image);

    overlayImage.onload = () => {
      toggleLoadingSpinner(image);
      image.parentElement.insertBefore(overlay, image);
      image.style.opacity = '100%';
    }

    return overlay;
  };

  function prepareOverlay(container, image) {
    container.setAttribute('class', 'image-magnify-full-size');
    container.setAttribute('aria-hidden', 'true');
    container.style.backgroundImage = `url('${image.src}')`;
    container.style.backgroundColor = 'var(--gradient-background)';
  }

  function toggleLoadingSpinner(image) {
    const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading-overlay__spinner`);
    loadingSpinner.classList.toggle('hidden');
  }

  function moveWithHover(image, event, zoomRatio, metrics) {
    // calculate mouse position (metrics are measured once per hover session,
    // not re-read from layout on every mousemove)
    const { rect, width, height, clientWidth } = metrics;
    const ratio = height / width;
    const xPosition = event.clientX - rect.left;
    const yPosition = event.clientY - rect.top;
    const xPercent = `${xPosition / (clientWidth / 100)}%`;
    const yPercent = `${yPosition / ((clientWidth * ratio) / 100)}%`;

    // determine what to show in the frame
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${width * zoomRatio}px`;
  };

  function magnify(image, zoomRatio, metrics) {
    const overlay = createOverlay(image);
    overlay.onclick = () => overlay.remove();
    overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, metrics);
    overlay.onmouseleave = () => overlay.remove();
  }

  function enableZoomOnHover(zoomRatio) {
    const images = document.querySelectorAll('.image-magnify-hover');
    images.forEach(image => {
      image.onclick = (event) => {
        const metrics = {
          rect: image.getBoundingClientRect(),
          width: image.width,
          height: image.height,
          clientWidth: image.clientWidth,
        };
        magnify(image, zoomRatio, metrics);
        moveWithHover(image, event, zoomRatio, metrics);
      };
    });
  }

  enableZoomOnHover(2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  if (!customElements.get('addresses-drawer')) {
    customElements.define('addresses-drawer', class AddressesDrawer extends Drawer {});
  }

  if (!customElements.get('address-button')) {
    customElements.define('address-button', class AddressDrawerButton extends DrawerButton {
      handleClick() {
        let action = (this.dataset.action) ? this.dataset.action : 'open';
        let addressAction = (this.innerText.toLowerCase().indexOf('edit') >= 0) ? 'edit' : 'add';
        this.drawer.classList.remove('drawer--edit-address','drawer--add-address');
        this.drawer.classList.add(`drawer--${addressAction}-address`);
        this.drawer.querySelector('.address-list .active')?.classList.remove('active');

        if (addressAction === 'edit') {
          this.drawer.querySelector(`#EditAddress_${this.dataset.addressId}`)?.classList.add('active');
        }

        if (action === 'open') {
          this.drawer.open();
        } else {
          this.drawer.close();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('contents-list')) {
    customElements.define('contents-list', class ContentsList extends HTMLElement {
      constructor() {
        super();

        this.articleContentHeadings = document.querySelectorAll(
          "[id^='template-article'] .article-main-content-wrapper .article-content-wrapper h1:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h2:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h3:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h4:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h5:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h1:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h2:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h3:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h4:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h5:not(.card__heading)",
        );

        this.addIDToHeadings(this.articleContentHeadings);
        this.populateContentsList(this.articleContentHeadings);
      }

      addIDToHeadings(headings) {
        if (headings) {
          headings.forEach((heading) => {
            heading.id = `article-${heading.innerHTML.toLowerCase().replace('?', '').replace(/\s+/g, '-').replace('<p>', '').replace('</p>', '')}`;

            const link = heading.querySelector('a');
            if (link) {
              heading.id = `article-${link.textContent.toLowerCase().replace('?', '').replace(/\s+/g, '-').replace('<p>', '').replace('</p>', '')}`;
            }
          });
        }
      }

      populateContentsList(headings) {
        if (headings.length > 0) {
          document.querySelector('.contents-list-wrapper').classList.remove('hidden');
          const ul = document.createElement('ul');
          headings.forEach((heading) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.textContent = heading.innerHTML.replace('<p>', '').replace('</p>', '');
            a.href = `#article-${heading.innerHTML.toLowerCase().replace('?', '').replace(/\s+/g, '-').replace('<p>', '').replace('</p>', '')}`;

            // if heading.innerHTML contains a link, get the links inner text and use that as the link text instead
            const link = heading.querySelector('a');
            if (link) {
              a.textContent = link.textContent;
              a.href = `#article-${link.textContent.toLowerCase().replace('?', '').replace(/\s+/g, '-').replace('<p>', '').replace('</p>', '')}`;
            }

            li.appendChild(a);

            a.addEventListener('click', (event) => {
              event.preventDefault();
              const targetId = a.getAttribute('href').substring(1);
              const targetElement = document.getElementById(targetId);
              const headerOffset = document.querySelector('.shopify-section-header-sticky sticky-header.header-wrapper').offsetHeight + 50;
              const elementPosition = targetElement.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
              });
            });

            ul.appendChild(li);
          });
          this.appendChild(ul);
        } else {
          document.querySelector('.contents-list-wrapper').classList.add('hidden');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Renamed from ShowMoreButton/'show-more-button' - that tag name is
  // already used by a different implementation in facets.liquid's own
  // JS block (desktop vertical-filter "show more values"), and
  // customElements.define() can only bind one class per tag name.
  if (!customElements.get('mobile-show-more-button')) {
    customElements.define('mobile-show-more-button', class MobileShowMoreButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.toggleShowMore.bind(this));
      }

      toggleShowMore() {
        this.closest('.mobile-facets__submenu')?.classList.toggle('mobile-facets__submenu--show-all')
      }
    });
  }

  // debounce/onKeyUpEscape are read from the global.js plain script - not
  // moved into a javascript block, so they remain genuine globals.
  if (!customElements.get('facet-filters-form')) {
    customElements.define('facet-filters-form', class FacetFiltersForm extends HTMLElement {
      constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
          this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

      }

      static setListeners() {
        const onHistoryChange = (event) => {
          const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
          if (searchParams === FacetFiltersForm.searchParamsPrev) return;
          FacetFiltersForm.renderPage(searchParams, null, false);
        }
        window.addEventListener('popstate', onHistoryChange);
      }

      static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
          element.classList.toggle('disabled', disable);
        });
      }

      static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer){
          countContainer.classList.add('loading');
        }
        if (countContainerDesktop){
          countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
          const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
          const filterDataUrl = element => element.url === url;

          FacetFiltersForm.filterData.some(filterDataUrl) ?
            FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
            FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);


      }

      static renderSectionFromFetch(url, event) {
        fetch(url)
          .then(response => response.text())
          .then((responseText) => {
            const html = responseText;
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
            FacetFiltersForm.renderFilters(html, event);
            FacetFiltersForm.renderProductGridContainer(html);
            FacetFiltersForm.renderProductCount(html);
          });
        }

        static renderSectionFromCache(filterDataUrl, event) {
          const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
      }

      static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
      }

      static renderProductCount(html) {


        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML

        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        const containerStatus = document.getElementById('ProductCountStatus');
        container.innerHTML = count;



        container.classList.remove('loading');
        if (containerDesktop) {
          containerDesktop.innerHTML = count;
          containerDesktop.classList.remove('loading');
        }
        if (containerStatus) {
          containerStatus.innerHTML = count;
        }
      }

      static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements =
          parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
        const matchesIndex = (element) => {
          const jsFilter = event ? event.target.closest('.js-filter') : undefined;
          return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
          document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
      }

      static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
          const activeFacetsElement = html.querySelector(selector);
          if (!activeFacetsElement) return;
          document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        })

        FacetFiltersForm.toggleActiveFacets(false);
      }

      static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
          if (!html.querySelector(selector)) return;
          document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
      }

      static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');

        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');

        if (sourceElement && targetElement) {
          target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
          target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
        }
      }

      static updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      }

      static getSections() {
        return [
          {
            section: document.getElementById('product-grid').dataset.id,
          }
        ]
      }

      createSearchParams(form) {
        // Create FormData object from the form
        const formData = new FormData(form);

        // dont apply price filter if min is empty and max is default max or both are empty
        const priceInputMax = form.querySelector('input.field-input--max')?.max;
        let maxKeyValue = null;
        let minKeyValue = null;
        formData.forEach((value, key) => {
          if (key === 'filter.v.price.lte') {
            maxKeyValue = value;
          }
          if (key === 'filter.v.price.gte') {
            minKeyValue = value;
          }
        });
        if( (minKeyValue == '' && maxKeyValue == priceInputMax) || (minKeyValue == 0 && maxKeyValue == priceInputMax) || (minKeyValue == '' && maxKeyValue == '')) {
          formData.delete('filter.v.price.gte');
          formData.delete('filter.v.price.lte');
        }

        // Convert FormData to URLSearchParams string
        return new URLSearchParams(formData).toString();
      }

      onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');

        const forms = [];
        let isMobile = window.innerWidth < 750

        window.matchMedia("(max-width: 749px)").addEventListener('change', (e) => {
          if (e.matches) {
            isMobile = true;
          } else {
            isMobile = false;
          }
        });

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortDrawerForm') {
              const noJsElements = document.querySelectorAll('.no-js-list');
              noJsElements.forEach((el) => el.remove());
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        });

        this.onSubmitForm(forms.join('&'), event)
      }

      onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
      }
    });

    // Static init - nothing outside this closure needs FacetFiltersForm by
    // name (confirmed), so a local reference is enough; no need to expose
    // it globally the way the old top-level class declaration implicitly did.
    const FacetFiltersFormClass = customElements.get('facet-filters-form');
    FacetFiltersFormClass.filterData = [];
    FacetFiltersFormClass.searchParamsInitial = window.location.search.slice(1);
    FacetFiltersFormClass.searchParamsPrev = window.location.search.slice(1);
    FacetFiltersFormClass.setListeners();
  }

  if (!customElements.get('price-range')) {
    customElements.define('price-range', class PriceRange extends HTMLElement {
      constructor() {
        super();

        const inputs = this.querySelectorAll('.field__input');
        this.minInput = inputs[0];
        this.maxInput = inputs[1];

        inputs.forEach(input => {
          input.addEventListener('change', () => this.syncFromInputs());

          // Format to 2 decimals when user finishes typing
          input.addEventListener('blur', () => {
            if (input.value !== '') {
              input.value = parseFloat(input.value).toFixed(2);
            }
          });
        });

        this.slider = this.querySelector('.js-range-slider');
        if (this.slider) this.initSlider();

        this.setMinAndMaxValues();
      }

      initSlider() {
        const minHandle = this.slider.querySelector('.range-handle--min');
        const maxHandle = this.slider.querySelector('.range-handle--max');
        const rangeTrack = this.slider.querySelector('.range-range');

        const sliderMin = Number(this.slider.dataset.min);
        const sliderMax = Number(this.slider.dataset.max);

        [minHandle, maxHandle].forEach(handle => {
          handle.min = sliderMin;
          handle.max = sliderMax;

          handle.addEventListener('input', () => {
            const minValue = Math.min(+minHandle.value, +maxHandle.value);
            const maxValue = Math.max(+minHandle.value, +maxHandle.value);

            minHandle.value = minValue;
            maxHandle.value = maxValue;

            // Display formatted values
            this.minInput.value = minValue ? minValue.toFixed(2) : '';
            this.maxInput.value = maxValue ? maxValue.toFixed(2) : '';

            const minPercent =
              ((minValue - sliderMin) / (sliderMax - sliderMin)) * 100;
            const maxPercent =
              ((maxValue - sliderMin) / (sliderMax - sliderMin)) * 100;

            rangeTrack.style.left = minPercent + '%';
            rangeTrack.style.width = maxPercent - minPercent + '%';

            this.dispatchEvent(
              new CustomEvent('rangeChange', { bubbles: true })
            );
          });
        });

        this.syncFromInputs();
      }

      syncFromInputs() {
        if (!this.slider) return;

        const minHandle = this.slider.querySelector('.range-handle--min');
        const maxHandle = this.slider.querySelector('.range-handle--max');

        minHandle.value = this.minInput.value
          ? parseFloat(this.minInput.value)
          : minHandle.min;

        maxHandle.value = this.maxInput.value
          ? parseFloat(this.maxInput.value)
          : maxHandle.max;

        // Trigger slider update
        minHandle.dispatchEvent(new Event('input'));
      }

      setMinAndMaxValues() {
        if (this.maxInput.value) {
          this.minInput.max = parseFloat(this.maxInput.value);
        }
        if (this.minInput.value) {
          this.maxInput.min = parseFloat(this.minInput.value);
        }
      }
    });
  }

  if (!customElements.get('facet-remove')) {
    customElements.define('facet-remove', class FacetRemove extends HTMLElement {
      constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
          event.preventDefault();
          if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
        if (this.hasAttribute('data-clear-all')) {
          // close drawer on clear all click
          facetLink.addEventListener('click', () => {
            const menuDrawer = this.closest('menu-drawer');
            if (menuDrawer) {
              menuDrawer.closeMenuDrawer('close');
            }
          });
        }
      }

      closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  if (!customElements.get('password-modal')) {
    customElements.define('password-modal', class PasswordModal extends DetailsModal {
      constructor() {
        super();

        if (this.querySelector('input[aria-invalid="true"]')) this.open({target: this.querySelector('details')});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-info')) {
    customElements.define('product-info', class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios')
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1
        }

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    });
  }

  // subscribe/publish/PUB_SUB_EVENTS/debounce/pauseAllMedia are all read
  // from plain global <script src> tags (pubsub.js, constants.js,
  // global.js) - none of those are moved into a javascript block, so
  // they remain genuine globals this closure can safely read.
  if (!customElements.get('product-modal')) {
    customElements.define(
      "product-modal",
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove("active");
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
          const activeMediaTemplate = activeMedia.querySelector("template");
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add("active");

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent && activeMediaContent.querySelector(".js-youtube")) activeMedia.loadContent();
        }
      }
    );
  }

  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        }
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({behavior: 'smooth'});
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position
          );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    });
  }

  if (!customElements.get('product-model')) {
    customElements.define('product-model', class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }
    });
  }

  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },

    setupShopifyXR(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
          this.setupShopifyXR()
        );
        return;
      }

      document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
        modelJSON.remove();
      });
      window.ShopifyXR.setupXRElements();
    },
  };

  window.addEventListener('DOMContentLoaded', () => {
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
  });

  // Fixes a pre-existing bug: this was previously an undeclared assignment
  // (`overlay = ...`), which happened to work as an accidental global in a
  // plain script but would throw in the strict-mode closure this tag wraps
  // content in. Declared properly here, shared between createOverlay() and
  // moveWithHover() exactly as before.
  let overlay;

  function createOverlay(image) {
    const overlayImage = document.createElement('img');
    overlayImage.setAttribute('src', `${image.src}`);
    overlay = document.createElement('div');
    prepareOverlay(overlay, overlayImage);

    image.style.opacity = '50%';
    toggleLoadingSpinner(image);

    overlayImage.onload = () => {
      toggleLoadingSpinner(image);
      image.parentElement.insertBefore(overlay, image);
      image.style.opacity = '100%';
    }

    return overlay;
  };

  function prepareOverlay(container, image) {
    container.setAttribute('class', 'image-magnify-full-size');
    container.setAttribute('aria-hidden', 'true');
    container.style.backgroundImage = `url('${image.src}')`;
    container.style.backgroundColor = 'var(--gradient-background)';
  }

  function toggleLoadingSpinner(image) {
    const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading-overlay__spinner`);
    loadingSpinner.classList.toggle('hidden');
  }

  function moveWithHover(image, event, zoomRatio, metrics) {
    // calculate mouse position (metrics are measured once per hover session,
    // not re-read from layout on every mousemove)
    const { rect, width, height, clientWidth } = metrics;
    const ratio = height / width;
    const xPosition = event.clientX - rect.left;
    const yPosition = event.clientY - rect.top;
    const xPercent = `${xPosition / (clientWidth / 100)}%`;
    const yPercent = `${yPosition / ((clientWidth * ratio) / 100)}%`;

    // determine what to show in the frame
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${width * zoomRatio}px`;
  };

  function magnify(image, zoomRatio, metrics) {
    const overlay = createOverlay(image);
    overlay.onclick = () => overlay.remove();
    overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, metrics);
    overlay.onmouseleave = () => overlay.remove();
  }

  function enableZoomOnHover(zoomRatio) {
    const images = document.querySelectorAll('.image-magnify-hover');
    images.forEach(image => {
      image.onclick = (event) => {
        const metrics = {
          rect: image.getBoundingClientRect(),
          width: image.width,
          height: image.height,
          clientWidth: image.clientWidth,
        };
        magnify(image, zoomRatio, metrics);
        moveWithHover(image, event, zoomRatio, metrics);
      };
    });
  }

  enableZoomOnHover(2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('main-search')) {
    customElements.define('main-search', class MainSearch extends SearchForm {
      constructor() {
        super();
        this.allSearchInputs = document.querySelectorAll('input[type="search"]');
        this.setupEventListeners();
      }

      setupEventListeners() {
        let allSearchForms = [];
        this.allSearchInputs.forEach(input => allSearchForms.push(input.form))
        this.input.addEventListener('focus', this.onInputFocus.bind(this));
        if (allSearchForms.length < 2) return;
        allSearchForms.forEach(form =>
          form.addEventListener('reset', this.onFormReset.bind(this))
        );
        this.allSearchInputs.forEach(input =>
          input.addEventListener('input', this.onInput.bind(this))
        );
      }

      onFormReset(event) {
        super.onFormReset(event);
        if (super.shouldResetForm()) {
          this.keepInSync('', this.input);
        }
      }

      onInput(event) {
        const target = event.target;
        this.keepInSync(target.value, target);
      }

      onInputFocus() {
        const isSmallScreen = window.innerWidth < 750;
        if (isSmallScreen) {
          this.scrollIntoView({behavior: 'smooth'});
        }
      }

      keepInSync(value, target) {
        this.allSearchInputs.forEach(input => {
          if (input !== target) {
            input.value = value;
          }
        });
      }
    });
  }

  // Renamed from ShowMoreButton/'show-more-button' - that tag name is
  // already used by a different implementation in facets.liquid's own
  // JS block (desktop vertical-filter "show more values"), and
  // customElements.define() can only bind one class per tag name.
  if (!customElements.get('mobile-show-more-button')) {
    customElements.define('mobile-show-more-button', class MobileShowMoreButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.toggleShowMore.bind(this));
      }

      toggleShowMore() {
        this.closest('.mobile-facets__submenu')?.classList.toggle('mobile-facets__submenu--show-all')
      }
    });
  }

  // debounce/onKeyUpEscape are read from the global.js plain script - not
  // moved into a javascript block, so they remain genuine globals.
  if (!customElements.get('facet-filters-form')) {
    customElements.define('facet-filters-form', class FacetFiltersForm extends HTMLElement {
      constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
          this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

      }

      static setListeners() {
        const onHistoryChange = (event) => {
          const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
          if (searchParams === FacetFiltersForm.searchParamsPrev) return;
          FacetFiltersForm.renderPage(searchParams, null, false);
        }
        window.addEventListener('popstate', onHistoryChange);
      }

      static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
          element.classList.toggle('disabled', disable);
        });
      }

      static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer){
          countContainer.classList.add('loading');
        }
        if (countContainerDesktop){
          countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
          const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
          const filterDataUrl = element => element.url === url;

          FacetFiltersForm.filterData.some(filterDataUrl) ?
            FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
            FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);


      }

      static renderSectionFromFetch(url, event) {
        fetch(url)
          .then(response => response.text())
          .then((responseText) => {
            const html = responseText;
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
            FacetFiltersForm.renderFilters(html, event);
            FacetFiltersForm.renderProductGridContainer(html);
            FacetFiltersForm.renderProductCount(html);
          });
        }

        static renderSectionFromCache(filterDataUrl, event) {
          const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
      }

      static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
      }

      static renderProductCount(html) {


        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML

        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;



        container.classList.remove('loading');
        if (containerDesktop) {
          containerDesktop.innerHTML = count;
          containerDesktop.classList.remove('loading');
        }
      }

      static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements =
          parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
        const matchesIndex = (element) => {
          const jsFilter = event ? event.target.closest('.js-filter') : undefined;
          return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
          document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
      }

      static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
          const activeFacetsElement = html.querySelector(selector);
          if (!activeFacetsElement) return;
          document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        })

        FacetFiltersForm.toggleActiveFacets(false);
      }

      static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
          if (!html.querySelector(selector)) return;
          document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
      }

      static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');

        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');

        if (sourceElement && targetElement) {
          target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
          target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
        }
      }

      static updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      }

      static getSections() {
        return [
          {
            section: document.getElementById('product-grid').dataset.id,
          }
        ]
      }

      createSearchParams(form) {
        // Create FormData object from the form
        const formData = new FormData(form);

        // dont apply price filter if min is empty and max is default max or both are empty
        const priceInputMax = form.querySelector('input.field-input--max')?.max;
        let maxKeyValue = null;
        let minKeyValue = null;
        formData.forEach((value, key) => {
          if (key === 'filter.v.price.lte') {
            maxKeyValue = value;
          }
          if (key === 'filter.v.price.gte') {
            minKeyValue = value;
          }
        });
        if( (minKeyValue == '' && maxKeyValue == priceInputMax) || (minKeyValue == 0 && maxKeyValue == priceInputMax) || (minKeyValue == '' && maxKeyValue == '')) {
          formData.delete('filter.v.price.gte');
          formData.delete('filter.v.price.lte');
        }

        // Convert FormData to URLSearchParams string
        return new URLSearchParams(formData).toString();
      }

      onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');

        const forms = [];
        let isMobile = window.innerWidth < 750

        window.matchMedia("(max-width: 749px)").addEventListener('change', (e) => {
          if (e.matches) {
            isMobile = true;
          } else {
            isMobile = false;
          }
        });

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortDrawerForm') {
              const noJsElements = document.querySelectorAll('.no-js-list');
              noJsElements.forEach((el) => el.remove());
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        });

        this.onSubmitForm(forms.join('&'), event)
      }

      onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
      }
    });

    // Static init - nothing outside this closure needs FacetFiltersForm by
    // name (confirmed), so a local reference is enough; no need to expose
    // it globally the way the old top-level class declaration implicitly did.
    const FacetFiltersFormClass = customElements.get('facet-filters-form');
    FacetFiltersFormClass.filterData = [];
    FacetFiltersFormClass.searchParamsInitial = window.location.search.slice(1);
    FacetFiltersFormClass.searchParamsPrev = window.location.search.slice(1);
    FacetFiltersFormClass.setListeners();
  }

  if (!customElements.get('price-range')) {
    customElements.define('price-range', class PriceRange extends HTMLElement {
      constructor() {
        super();

        const inputs = this.querySelectorAll('.field__input');
        this.minInput = inputs[0];
        this.maxInput = inputs[1];

        inputs.forEach(input => {
          input.addEventListener('change', () => this.syncFromInputs());

          // Format to 2 decimals when user finishes typing
          input.addEventListener('blur', () => {
            if (input.value !== '') {
              input.value = parseFloat(input.value).toFixed(2);
            }
          });
        });

        this.slider = this.querySelector('.js-range-slider');
        if (this.slider) this.initSlider();

        this.setMinAndMaxValues();
      }

      initSlider() {
        const minHandle = this.slider.querySelector('.range-handle--min');
        const maxHandle = this.slider.querySelector('.range-handle--max');
        const rangeTrack = this.slider.querySelector('.range-range');

        const sliderMin = Number(this.slider.dataset.min);
        const sliderMax = Number(this.slider.dataset.max);

        [minHandle, maxHandle].forEach(handle => {
          handle.min = sliderMin;
          handle.max = sliderMax;

          handle.addEventListener('input', () => {
            const minValue = Math.min(+minHandle.value, +maxHandle.value);
            const maxValue = Math.max(+minHandle.value, +maxHandle.value);

            minHandle.value = minValue;
            maxHandle.value = maxValue;

            // Display formatted values
            this.minInput.value = minValue ? minValue.toFixed(2) : '';
            this.maxInput.value = maxValue ? maxValue.toFixed(2) : '';

            const minPercent =
              ((minValue - sliderMin) / (sliderMax - sliderMin)) * 100;
            const maxPercent =
              ((maxValue - sliderMin) / (sliderMax - sliderMin)) * 100;

            rangeTrack.style.left = minPercent + '%';
            rangeTrack.style.width = maxPercent - minPercent + '%';

            this.dispatchEvent(
              new CustomEvent('rangeChange', { bubbles: true })
            );
          });
        });

        this.syncFromInputs();
      }

      syncFromInputs() {
        if (!this.slider) return;

        const minHandle = this.slider.querySelector('.range-handle--min');
        const maxHandle = this.slider.querySelector('.range-handle--max');

        minHandle.value = this.minInput.value
          ? parseFloat(this.minInput.value)
          : minHandle.min;

        maxHandle.value = this.maxInput.value
          ? parseFloat(this.maxInput.value)
          : maxHandle.max;

        // Trigger slider update
        minHandle.dispatchEvent(new Event('input'));
      }

      setMinAndMaxValues() {
        if (this.maxInput.value) {
          this.minInput.max = parseFloat(this.maxInput.value);
        }
        if (this.minInput.value) {
          this.maxInput.min = parseFloat(this.minInput.value);
        }
      }
    });
  }

  if (!customElements.get('facet-remove')) {
    customElements.define('facet-remove', class FacetRemove extends HTMLElement {
      constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
          event.preventDefault();
          if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
        if (this.hasAttribute('data-clear-all')) {
          // close drawer on clear all click
          facetLink.addEventListener('click', () => {
            const menuDrawer = this.closest('menu-drawer');
            if (menuDrawer) {
              menuDrawer.closeMenuDrawer('close');
            }
          });
        }
      }

      closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slideshow-indicators')) {
    customElements.define('slideshow-indicators', class SlideshowIndicators extends HTMLElement {
      constructor() {
        super();

        this.slider = document.querySelector(this.dataset.targetEl);
        this.sliderList = this.slider.querySelector(".slideshow__slides");
        this.autoplay = this.slider.dataset.autoplay === "true" ? true : false;
        this.autoplayDelay = parseInt(this.slider.dataset.autoplayDelay) ? parseInt(this.slider.dataset.autoplayDelay) * 1000 : 5000;

        this.sliderAutoplayButton = this.slider.querySelector(".slideshow__autoplay");
        this.sliderAutoplayButton?.addEventListener("click", this.autoPlayToggle.bind(this));

        if (!this.sliderList) {
          return;
        }

        this.slides = this.sliderList.querySelectorAll(".slideshow__slide");
        this.observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.5,
        };

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.observerOptions);

        this.slides.forEach((slide, index) => {
          this.observer.observe(slide);

          slide.dataset.slideIndex = index;
        });

        this.autoplayProgress = 0;
        this.autoplayAnimationFrameId = null;
        this.currentSlideIndex = 0;
        this.userInteraction = false;

        if (this.autoplay) {
          this.autoplayIsRunning = true;
          this.startAutoplay(this.autoplayDelay);
          this.slider.addEventListener("mouseenter", () => this.pauseAutoplay());
          this.slider.addEventListener("mouseleave", () => this.resumeAutoPlay());
        } else {
          this.autoplayIsRunning = false;
          // Not calling stopAutoPlay() here - its classList.add("no-autoplay")
          // would run synchronously during this constructor, which fires very
          // early in page load and can force a pending style recalculation to
          // flush immediately. connectedCallback() below applies that same
          // class (deferred a frame); userInteraction only needs to be set,
          // not the DOM write, at this point (pauseAutoplay() would be a
          // no-op here too, since autoplayAnimationFrameId is never set when
          // autoplay is disabled).
          this.userInteraction = true;
        }

        let startX = 0;
        let isSwiping = false;

        this.slider.addEventListener("mousedown", (event) => {
          startX = event.clientX;
          isSwiping = true;
          this.stopAutoPlay();
        });

        this.slider.addEventListener("mousemove", (event) => {
          if (!isSwiping) return;
          const deltaX = event.clientX - startX;
          if (Math.abs(deltaX) > 20) {
            isSwiping = false;
            this.stopAutoPlay();
          }
        });

        this.slider.addEventListener("mouseup", () => {
          isSwiping = false;
        });

        this.slider.addEventListener(
          "wheel",
          (event) => {
            if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
              this.stopAutoPlay();
            }
          },
          { passive: true }
        );
        this.currentSlideIndexBefore = 0;
      }

      handleIntersection = (entries) => {
        entries.forEach((entry, index) => {
          const slide = entry.target;
          const slideIndex = slide.dataset.slideIndex;

          if (entry.isIntersecting) {
            this.activateSlide(slideIndex);
          }
        });
      };

      activateSlide(slideIndex) {
        const activeSlide = this.querySelector("ul > li.active");
        if (activeSlide) {
          activeSlide.classList.remove("active");
          activeSlide.style.setProperty("--delay-progress", `100%`);
        }

        const targetSlide = this.querySelectorAll(`ul > li`)[slideIndex];
        if (targetSlide) {
          targetSlide.classList.add("active");
          if (!this.userInteraction) {
            targetSlide.style.setProperty("--delay-progress", `0%`);
          } else {
            targetSlide.style.setProperty("--delay-progress", `100%`);
          }
        }

        this.currentSlideIndexBefore = slideIndex;
      }

      startAutoplay(autoplayDelay) {
        this.autoplayProgress = 0;
        let startTime = performance.now();
        let animationFrameId;

        const animateAutoplay = () => {
          const currentTime = performance.now();
          const elapsedTime = currentTime - startTime;

          if (!this.userInteraction) {
            this.logAutoplayProgress();
          }

          this.autoplayProgress = (elapsedTime / autoplayDelay) * 100;

          if (this.autoplayProgress >= 100) {
            this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
            this.changeSlide(this.currentSlideIndex);
            this.autoplayProgress = 0;
            startTime = currentTime;
          }

          if (!this.userInteraction) {
            animationFrameId = requestAnimationFrame(animateAutoplay);
          }

          this.autoplayAnimationFrameId = animationFrameId;
        };

        if (!this.autoplayAnimationFrameId) {
          animationFrameId = requestAnimationFrame(animateAutoplay);
        }

        this.autoplayAnimationFrameId = animationFrameId;
      }

      stopAutoPlay() {
        this.userInteraction = true;
        this.slider.classList.add("no-autoplay");
        this.pauseAutoplay();
      }

      resumeAutoPlay() {
        if (!this.autoplayAnimationFrameId && !this.userInteraction) {
          this.startAutoplay(this.autoplayDelay);

          this.sliderAutoplayButton?.classList.remove("slideshow__autoplay--paused");
          this.sliderAutoplayButton?.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
          this.autoplayIsRunning = true;
        }
      }

      pauseAutoplay() {
        if (this.autoplayAnimationFrameId && !this.userInteraction) {
          cancelAnimationFrame(this.autoplayAnimationFrameId);
          this.autoplayAnimationFrameId = null;

          this.sliderAutoplayButton?.classList.add("slideshow__autoplay--paused");
          this.sliderAutoplayButton?.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
          this.autoplayIsRunning = false;
        }
      }

      autoPlayToggle() {
        if (this.autoplayIsRunning) {
          this.stopAutoPlay();
          this.sliderAutoplayButton?.classList.add("slideshow__autoplay--paused");
          this.sliderAutoplayButton?.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
          this.autoplayIsRunning = false;
        } else {
          this.startAutoplay(this.autoplayDelay);
          this.sliderAutoplayButton?.classList.remove("slideshow__autoplay--paused");
          this.sliderAutoplayButton?.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
          this.autoplayIsRunning = true;
          this.userInteraction = false;
        }
      }

      logAutoplayProgress() {
        const activeIndicator = this.slider.querySelector(".active");
        if (activeIndicator) {
          const currentDelayProgress = parseFloat(activeIndicator.style.getPropertyValue("--delay-progress"));

          if (currentDelayProgress <= this.autoplayProgress && this.autoplayProgress > 5) {
            activeIndicator.style.setProperty("--delay-progress", `${this.autoplayProgress.toFixed(0)}%`);
          }
        }
      }

      changeSlide(slideIndex) {
        const targetSlide = this.slides[slideIndex];
        if (targetSlide) {
          this.sliderList.scroll({
            left: targetSlide.offsetLeft,
            behavior: "smooth",
          });
        }
      }

      changeSlideFade(slideIndex) {
        const targetSlide = this.slides[slideIndex];
        if (targetSlide) {
          this.sliderList.style.transition = "opacity 0.5s";
          this.sliderList.style.opacity = 0;
          setTimeout(() => {
            this.sliderList.scroll({
              left: targetSlide.offsetLeft,
              behavior: "instant",
            });
            this.sliderList.style.opacity = 1;
          }, 100);
        }
      }

      connectedCallback() {
        // add class to slider if autoplay is not enabled
        if (!this.autoplay) {
          // Deferred a frame - connectedCallback() also fires very early in
          // page load, so writing this class synchronously risks forcing a
          // pending style recalculation to flush immediately (see the
          // matching note in the constructor above).
          requestAnimationFrame(() => this.slider.classList.add("no-autoplay"));
        }

        const buttons = this.querySelectorAll("button:not(.slide-nav)");
        const buttonsNav = this.querySelectorAll("button.slide-nav");

        buttons.forEach((button, index) => {
          button.addEventListener("click", () => {
            this.changeSlide(index);
            if (this.autoplayAnimationFrameId) {
              this.stopAutoPlay();
            }
          });
        });

        buttonsNav.forEach((button, index) => {
          button.addEventListener("click", () => {
            if (button.classList.contains("pdp-media-indicators__button_next")) {
              this.currentIndex = (parseInt(this.currentSlideIndexBefore) + 1) % this.slides.length;
            } else if (button.classList.contains("pdp-media-indicators__button_previous")) {
              this.currentIndex = parseInt(this.currentSlideIndexBefore) - 1;
            }

            if (this.currentIndex < 0) {
              this.currentIndex = this.slides.length - 1;
            }

            this.changeSlide(this.currentIndex);

            if (this.autoplayAnimationFrameId) {
              this.stopAutoPlay();
            }
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison-table"]) return;
  try {
    
  if (!customElements.get('comparison-table')) {
    customElements.define('comparison-table', class ComparisonTable extends HTMLElement {
      constructor() {
        super();
        this.viewMoreButton = this.querySelector('.js-view-more');
        this.viewLessButton = this.querySelector('.js-view-less');
        this.hiddenRows = this.querySelectorAll('.product-comparison__key.hidden, .product-comparison__data.hidden');
        this.addEventListeners();
      }

      addEventListeners() {
        if (this.viewMoreButton) {
          this.viewMoreButton.addEventListener('click', () => this.showMore());
        }

        if (this.viewLessButton) {
          this.viewLessButton.addEventListener('click', () => this.showLess());
        }
      }

      showMore() {
        this.hiddenRows.forEach((row) => row.classList.remove('hidden'));
        this.viewMoreButton.classList.add('hidden');
        this.viewLessButton.classList.remove('hidden');
      }

      showLess() {
        this.hiddenRows.forEach((row) => row.classList.add('hidden'));
        this.viewMoreButton.classList.remove('hidden');
        this.viewLessButton.classList.add('hidden');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-links"] && !Shopify.designMode) return;
  try {
    
          if (!customElements.get('quick-links-slider')) {
            customElements.define('quick-links-slider', class QuickLinksSlider extends HTMLElement {
              connectedCallback() {
                this.slider = this.querySelector('.category-quick-links__items');
                this.prevButton = this.querySelector('.slider-button--prev');
                this.nextButton = this.querySelector('.slider-button--next');

                if (!this.slider || !this.prevButton || !this.nextButton) return;

                this.prevButton.addEventListener('click', () => {
                  this.slider.scrollBy({ left: -this.slider.clientWidth, behavior: 'smooth' });
                });

                this.nextButton.addEventListener('click', () => {
                  this.slider.scrollBy({ left: this.slider.clientWidth, behavior: 'smooth' });
                });

                this.slider.addEventListener('scroll', this.updateButtons, { passive: true });
                window.addEventListener('resize', this.updateButtons);

                // Deferred to the next frame so this doesn't force a
                // synchronous layout read (scrollLeft/scrollWidth/
                // clientWidth) immediately on connect, before the browser
                // has laid out the rest of the page.
                requestAnimationFrame(this.updateButtons);
              }

              disconnectedCallback() {
                window.removeEventListener('resize', this.updateButtons);
              }

              updateButtons = () => {
                if (!this.slider) return;
                this.prevButton.disabled = this.slider.scrollLeft === 0;
                this.nextButton.disabled = this.slider.scrollLeft >= this.slider.scrollWidth - this.slider.clientWidth;
              };
            });
          }
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-shopify-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shopify-form')) {
    customElements.define('shopify-form', class ShopifyForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector(".shopify-form--app-block");
        this.showFormButton = this.querySelector("button[data-show-form]");
        this.hideFormButton = this.querySelector("button[data-hide-form]");
      }

      connectedCallback() {
        this.showFormButton.addEventListener("click", () => this.showForm());
        this.hideFormButton.addEventListener("click", () => this.hideForm());
      }

      showForm() {
        if (this.form) {
          this.form.style.display = "block";
        }
        this.showFormButton.style.display = "none";
      }

      hideForm() {
        this.form.style.display = "none";
        this.showFormButton.style.display = "flex";
        // scroll to top of the component
        const yOffset = -200;
        const y = this.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-bundles"]) return;
  try {
    
  if (!customElements.get('tabbed-bundles')) {
    customElements.define('tabbed-bundles', class TabbedBundles extends HTMLElement {
      constructor() {
        super();

        this.tabs = this.querySelectorAll('.js-bundle-tab');
        this.desktopProducts = this.querySelectorAll('.js-bundle-product--desktop');
        this.mobileProducts = this.querySelectorAll('.js-bundle-product');
        this.mediaQuery = window.matchMedia('(min-width: 750px)');

        this.initialise();
      }

      initialise() {
        this.setProducts();
        this.handleMediaQueryChange();

        this.mediaQuery.addEventListener('change', this.handleMediaQueryChange.bind(this));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const tabId = tab.getAttribute('data-tab');
            this.switchProduct(tabId);
            this.updateActiveTab(tab);
          });
        });
      }

      setProducts() {
        this.products = this.mediaQuery.matches ? this.desktopProducts : this.mobileProducts;
      }

      handleMediaQueryChange() {
        this.setProducts();
        this.mediaQuery.matches ? this.resetDesktop() : this.resetMobile();
      }

      updateActiveTab(activeTab) {
        this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab === activeTab));
      }

      switchProduct(id) {
        this.products.forEach((product) => {
          const tabId = product.getAttribute('data-tab');
          product.classList.toggle('hidden', tabId !== id);

          if (tabId === id) {
            product.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      resetDesktop() {
        this.hideAll(this.mobileProducts);
        this.resetTabs();
        this.showFirstProduct();
      }

      resetMobile() {
        this.hideAll(this.desktopProducts);
        this.hideAll(this.products);
        this.resetTabs();
      }

      hideAll(elements) {
        elements.forEach((element) => element.classList.add('hidden'));
      }

      resetTabs() {
        this.tabs.forEach((tab) => tab.classList.remove('is-active'));
      }

      showFirstProduct() {
        this.tabs[0]?.classList.add('is-active');
        this.products[0]?.classList.remove('hidden');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua_frequently-asked-questions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion-list')) {
    customElements.define('faq-accordion-list', class FaqAccordionList extends HTMLElement {
      connectedCallback() {
        this.accordions = this.querySelectorAll('[data-faq-accordion]');

        this.accordions.forEach((accordion) => {
          const headerButton = accordion.querySelector('.faq-accordion__header');
          if (!headerButton) return;

          headerButton.addEventListener('click', () => {
            const isOpen = accordion.classList.contains('faq-accordion--open');
            const expanded = !isOpen;

            accordion.classList.toggle('faq-accordion--open', expanded);
            headerButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');

            this.setMaxHeight(accordion);
          });
        });

        this.onResize = () => {
          this.accordions.forEach((accordion) => {
            if (accordion.classList.contains('faq-accordion--open')) {
              this.setMaxHeight(accordion);
            }
          });
        };
        window.addEventListener('resize', this.onResize);

        // Set every accordion's initial height in one batch - read all of
        // them first, then write all of them - instead of read-then-write
        // per item, and deferred a frame so this doesn't force a layout
        // mid-parse, before the browser has laid out the rest of the page.
        requestAnimationFrame(() => {
          const items = Array.from(this.accordions, (accordion) => ({
            accordion,
            bodyWrapper: accordion.querySelector('[data-faq-content]'),
          })).filter((item) => item.bodyWrapper);

          const heights = items.map(({ accordion, bodyWrapper }) =>
            accordion.classList.contains('faq-accordion--open') ? bodyWrapper.scrollHeight : 0
          );

          items.forEach(({ accordion, bodyWrapper }, index) => {
            bodyWrapper.style.maxHeight = accordion.classList.contains('faq-accordion--open') ? heights[index] + 'px' : 0;
          });
        });
      }

      disconnectedCallback() {
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      setMaxHeight(accordion) {
        const bodyWrapper = accordion.querySelector('[data-faq-content]');
        if (!bodyWrapper) return;

        bodyWrapper.style.maxHeight = accordion.classList.contains('faq-accordion--open') ? bodyWrapper.scrollHeight + 'px' : 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1079px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.addDropdownHoverListeners();
    }

    setHeaderHeight() {
      //document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      //document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar ? this.announcementBar.offsetHeight : 0}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    addDropdownHoverListeners() {
      const dropdownItems = this.header.querySelectorAll('.dropdown-item');

      dropdownItems.forEach((item) => {
        const details = item.closest('details');
        let closeTimeout;

        if (details) {
          // Open the dropdown on mouseenter
          item.addEventListener('mouseenter', () => {
            clearTimeout(closeTimeout); // Clear any pending close timeout

            // Close all other open details elements
            this.header.querySelectorAll('details[open]').forEach((openDetails) => {
              if (openDetails !== details) {
                openDetails.removeAttribute('open');
              }
            });

            details.setAttribute('open', 'true');
          });

          // Keep the dropdown open when hovering over the submenu
          const submenu = details.querySelector('.header__submenu');
          if (submenu) {
            submenu.addEventListener('mouseenter', () => {
              clearTimeout(closeTimeout); // Prevent closing while hovering over the submenu
            });

            submenu.addEventListener('mouseleave', () => {
              closeTimeout = setTimeout(() => {
                details.removeAttribute('open');
              }, 200); // Add a small delay before closing
            });
          }

          // Close the dropdown on mouseleave
          item.addEventListener('mouseleave', () => {
            closeTimeout = setTimeout(() => {
              details.removeAttribute('open');
            }, 200); // Add a small delay before closing
          });
        }
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('mega-menu')) {
    window.customElements.define(
      "mega-menu",
      class Megamenu extends HTMLElement {
        megamenuCurrentClass = "megamenu--current";
        megamenuVisibleClass = "megamenu--isVisible";
        megamenuAnimateClass = "megamenu--animate";
        bodyClass = "megamenu--isActive";
        megamenuElClass = '[id^="shopify-section-sections"] #megamenu';
        mainNavTarget = "header .header__menu-item.megamenu-item";
        curtainTarget = "mega-menu-curtain";
        megamenuEl = null;
        timer = null;
        menuLinkHoverDuration = 1;

        constructor() {
          super();
        }

        connectedCallback() {
          this.addCurtain();
          this.addMeganavToHeader();

          // Event listeners
          this.windowEventScroll();
          this.linkEventMouseover();
          this.curtainEventClick();
          this.linkEventMouseout();
          this.curtainEventMouseover();
          this.linkEventFocus();
          this.linkEventFocusOut();
          this.keydownEventEscape();
          this.keydownEventTab();
        }

        disconnectedCallback() {
          if (this.megamenuEl) this.megamenuEl.remove();
        }

        // Methods
        addCurtain() {
          if (document.getElementById("megamenu")) return;
          this.innerHTML = "<mega-menu-curtain></mega-menu-curtain>" + this.innerHTML;
        }

        addMeganavToHeader() {
          document.querySelector('[id^="shopify-section-sections"] .header-wrapper').insertAdjacentHTML("afterend", this.innerHTML);
          this.innerHTML = "";
          this.megamenuEl = document.querySelector(this.megamenuElClass);
        }

        removeAnimation() {
          this.megamenuEl.classList.remove(this.megamenuAnimateClass);
          document.body.classList.remove(this.bodyClass);
        }

        showMegamenuItem(menuItemEl) {
          if (!menuItemEl) return;

          const title = menuItemEl.dataset.title;
          let megamenuId = "megamenu-" + title;

          let megamenuItemEl = document.getElementById(megamenuId);
          let inheritedMenuLinks = document.querySelectorAll(`.header__inline-menu a[data-title="${title}"]`);

          if (!megamenuItemEl) {
            this.hideAllMenuItems();
            this.removeAnimation();
            clearTimeout(this.timer);
            return;
          }

          let timerHoverDuration = this.menuIsVisible() ? 0 : this.menuLinkHoverDuration;

          let self = this;
          this.timer = setTimeout(function () {
            // prepare menu for animation
            document.body.classList.add(self.bodyClass);
            self.megamenuEl.classList.add(self.megamenuAnimateClass);

            // show mega menu item
            setTimeout(function () {
              self.hideAllMenuItems();
              inheritedMenuLinks.forEach((link) => {
                link.classList.add(self.megamenuCurrentClass);
                link.setAttribute("aria-expanded", "true");
              });
              megamenuItemEl.classList.add(self.megamenuVisibleClass);
              megamenuItemEl.setAttribute("aria-hidden", "false");
              megamenuItemEl.removeAttribute("inert");
            }, timerHoverDuration);
          }, timerHoverDuration);
        }

        hideAllMenuItems() {
          // hide mega menu item
          let currentMenuItems = document.querySelectorAll("." + this.megamenuCurrentClass);
          if (currentMenuItems) {
            for (var i = 0; i < currentMenuItems.length; i++) {
              let currentMenuItem = currentMenuItems[i];
              currentMenuItem.classList.remove(this.megamenuCurrentClass);
              currentMenuItem.setAttribute("aria-expanded", "false");
            }
          }

          let visibleMenuItems = document.querySelectorAll("." + this.megamenuVisibleClass);
          if (visibleMenuItems) {
            for (var i = 0; i < visibleMenuItems.length; i++) {
              let visibleMenuItem = visibleMenuItems[i];
              visibleMenuItem.classList.remove(this.megamenuVisibleClass);
              visibleMenuItem.setAttribute("aria-hidden", "true");
              visibleMenuItem.setAttribute("inert", "");
            }
          }
        }

        menuIsVisible() {
          return document.querySelector("#megamenu.megamenu--animate") ? true : false;
        }

        // Event Listeners
        curtainEventClick() {
          const self = this;
          document.addEventListener("click", function (e) {
            if (!e.target.closest(self.curtainTarget)) return false;
            self.hideAllMenuItems();
            self.removeAnimation();
          });
        }

        curtainEventMouseover() {
          const self = this;
          document.addEventListener("mouseover", function (e) {
            if (!e.target.closest(self.curtainTarget)) return false;
            if (!self.menuIsVisible()) return;

            clearTimeout(self.timer);
            self.hideAllMenuItems();
            self.removeAnimation();
          });
        }

        windowEventScroll() {
          const self = this;
          window.addEventListener("scroll", function (e) {
            self.hideAllMenuItems();
            self.removeAnimation();
          });
        }

        linkEventMouseover() {
          const self = this;
          document.addEventListener("mouseover", function (e) {
            if (!e.target.closest(self.mainNavTarget)) return false;
            self.showMegamenuItem(e.target);
          });
        }

        linkEventMouseout() {
          const self = this;
          document.addEventListener("mouseout", function (e) {
            if (!e.target.closest(self.mainNavTarget)) return false;
            clearTimeout(self.timer);
          });
        }

        linkEventFocus() {
          const self = this;
          document.addEventListener("focusin", function (e) {
            if (!e.target.closest(self.mainNavTarget)) return false;
            self.showMegamenuItem(e.target);
          });
        }

        linkEventFocusOut() {
          const self = this;
          document.addEventListener("focusout", function (e) {
            if (!e.target.closest(self.mainNavTarget) && !e.target.closest("#megamenu")) return false;

            setTimeout(function () {
              const activeEl = document.activeElement;
              if (activeEl && (activeEl.closest(self.mainNavTarget) || activeEl.closest("#megamenu"))) return;

              self.hideAllMenuItems();
              self.removeAnimation();
              clearTimeout(self.timer);
            });
          });
        }

        keydownEventEscape() {
          const self = this;
          document.addEventListener("keydown", function (e) {
            if (e.code.toUpperCase() !== "ESCAPE") return;
            if (!self.menuIsVisible()) return;

            const trigger = document.querySelector(self.mainNavTarget + '[aria-expanded="true"]');

            self.hideAllMenuItems();
            self.removeAnimation();
            clearTimeout(self.timer);

            if (trigger) trigger.focus();
          });
        }

        // Contains Tab within an open mega-menu panel: forward-tabbing off the
        // trigger enters the panel (it isn't next to the trigger in DOM order -
        // addMeganavToHeader() moved it elsewhere), tabbing off the panel's last
        // item releases to the next top-level nav item (which may open its own
        // panel and repeat), and Shift+Tab off the panel's first item returns to
        // the trigger. This is a bounded hand-off, not an infinite modal trap.
        keydownEventTab() {
          const self = this;
          document.addEventListener("keydown", function (e) {
            if (e.code.toUpperCase() !== "TAB") return;

            const active = document.activeElement;
            if (!active) return;

            // Forward-tabbing off an open trigger enters its panel
            if (!e.shiftKey && active.matches(self.mainNavTarget) && active.getAttribute("aria-expanded") === "true") {
              const panel = document.getElementById(active.getAttribute("aria-controls"));
              if (!panel) return;

              const panelFocusable = getFocusableElements(panel);
              if (!panelFocusable.length) return;

              e.preventDefault();
              panelFocusable[0].focus();
              return;
            }

            // Tabbing within the currently open panel
            const openPanel = active.closest("#megamenu ." + self.megamenuVisibleClass);
            if (!openPanel) return;

            const focusable = getFocusableElements(openPanel);
            if (!focusable.length) return;

            const currentIndex = focusable.indexOf(active);

            if (!e.shiftKey && currentIndex === focusable.length - 1) {
              // Last item in the panel - release to the next top-level nav item.
              // Several triggers can share one panel (title_inherit content reuse),
              // so skip past every sibling still pointing at this same panel rather
              // than re-entering identical content on each hand-off.
              const trigger = document.querySelector(self.mainNavTarget + '[aria-expanded="true"]');
              const allTriggers = Array.from(document.querySelectorAll(self.mainNavTarget));
              const triggerIndex = trigger ? allTriggers.indexOf(trigger) : -1;

              let nextTrigger = null;
              if (triggerIndex > -1) {
                for (let i = triggerIndex + 1; i < allTriggers.length; i++) {
                  if (allTriggers[i].getAttribute("aria-controls") !== openPanel.id) {
                    nextTrigger = allTriggers[i];
                    break;
                  }
                }
              }

              // No next item: let Tab continue naturally past the header;
              // the existing focusout handler closes this panel once focus lands outside it.
              if (!nextTrigger) return;

              e.preventDefault();
              nextTrigger.focus();
            } else if (e.shiftKey && currentIndex === 0) {
              // First item in the panel - Shift+Tab returns to the trigger
              const trigger = document.querySelector(self.mainNavTarget + '[aria-expanded="true"]');
              if (!trigger) return;

              e.preventDefault();
              trigger.focus();
            }
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua_mobilemenu"]) return;
  try {
    
  if (!customElements.get('mobile-menu')) {
    window.customElements.define(
      'mobile-menu',
      class MobileMenu extends HTMLElement {
        constructor() {
          super();

          this.isVisible = false;
          this.transitionTime = 300;
          this.animationStyle = null;
          this.mobilemenuEl = null;
          this.pageWrapEl = null;
          this.isHiddenClass = 'mobilemenu--hidden';
          this.isVisibleClass = 'mobilemenu--isVisible';
          this.isActiveClass = 'active';
          this.dropdownListTarget = '.mobilemenu__link[aria-expanded]';
          this.dropdownExpandedListTarget = '.mobilemenu__link[aria-expanded="true"]';
          this.tierActiveTarget = 'mobile-menu-tier.' + this.isActiveClass;
          this.linkTarget = '.mobilemenu__link';
          this.mobilemenuToggleTarget = '[data-mobilemenu="toggle"]';
          this.mobilemenuCloseTarget = 'mobile-menu-button-close,mobile-menu-curtain, button.mobile-menu-button-close';
          this.header = document.querySelector('.section-header');
          this.annoucementBar = document.querySelector('.announcement-bar-section');
        }

        connectedCallback() {
          this.mobilemenuAddCurtain();
          this.mobilemenuEl = this.querySelector('mobile-menu #mobilemenu');
          this.pageWrapEl = document.querySelector('.mobile-menu-page');
          this.setMobilemenuAnimationStyle();
          this.setMobilemenu();

          let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
          for (var i = 0; i < toggleButtons.length; i++) {
            toggleButtons[i].addEventListener('click', this.toggleButtonEventClick.bind(this));
          }

          // Event Listeners
          this.addEventListener('click', this.mobilemenuCloseEventClick.bind(this));
          this.addEventListener('click', this.dropdownListEventClick.bind(this));
          this.addEventListener('click', this.backButtonEventClick.bind(this));
          this.addEventListener('keyup', this.mobilemenuEventKeyupEscape.bind(this));
          //this.addEventListener('click',this.tierLinkEventClick.bind(this));
        }

        disconnectedCallback() {
          // Remove classes
          this.pageWrapEl.classList.remove('active');
          this.pageWrapEl.classList.remove('mobilemenu--push-left');
          this.pageWrapEl.classList.remove('mobilemenu--push-right');
          this.pageWrapEl.classList.remove('mobilemenu--overlay-left');
          this.pageWrapEl.classList.remove('mobilemenu--overlay-right');
          this.pageWrapEl.classList.remove('mobilemenu--overlay-bottom');

          // Remove eventListeners
          let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
          for (var i = 0; i < toggleButtons.length; i++) {
            toggleButtons[i].removeEventListener('click', this.toggleButtonEventClick.bind(this));
          }

          this.removeEventListener('click', this.mobilemenuCloseEventClick.bind(this));
          this.removeEventListener('click', this.dropdownListEventClick.bind(this));
          this.removeEventListener('click', this.backButtonEventClick.bind(this));
          this.removeEventListener('keyup', this.mobilemenuEventKeyupEscape.bind(this));
          //this.removeEventListener('click',this.tierLinkEventClick.bind(this));

          // Reset properties
          this.animationStyle = null;
        }

        // Methods
        mobilemenuHide() {
          this.mobilemenuEl.setAttribute('data-expanded', 'false');
          this.classList.remove(this.isVisibleClass);
          this.pageWrapEl.classList.remove(this.isActiveClass);
          this.isVisible = false;
          document.body.classList.remove('overflow-hidden');
          this.setToggleButtonsExpanded(false);
          removeTrapFocus(this.mobilemenuOpenTriggerEl);

          if (this.header) {
            this.header.classList.remove('reset-z-index');
          }
          if (this.annoucementBar) {
            this.annoucementBar.classList.remove('reset-z-index');
          }

          const closeMenuElement = document.querySelectorAll('.menu-drawer__menu .menu-opening .menu-drawer__close-button');

          closeMenuElement.forEach((closeMenuElement) => {
            closeMenuElement.click();
          });
        }

        closeMenuEventClick() {
          this.mobilemenuHide();
        }

        mobilemenuShow() {
          this.mobilemenuEl.setAttribute('data-expanded', 'true');
          this.classList.add(this.isVisibleClass);
          this.pageWrapEl.classList.add(this.isActiveClass);
          this.isVisible = true;
          document.body.classList.add('overflow-hidden');
          this.setToggleButtonsExpanded(true);

          const closeButton = this.querySelector('.menu-drawer__close-button');
          trapFocus(this.mobilemenuEl, closeButton || undefined);
        }

        setToggleButtonsExpanded(expanded) {
          let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
          for (var i = 0; i < toggleButtons.length; i++) {
            toggleButtons[i].setAttribute('aria-expanded', expanded);
          }
        }

        toggleButtonEventClick(event) {
          if (!this.isVisible) {
            this.mobilemenuOpenTriggerEl = event.currentTarget;
          }
          this.mobilemenuToggle();
          //this.setFirstTier();
        }

        mobilemenuEventKeyupEscape(event) {
          if (event.code.toUpperCase() !== 'ESCAPE') return;
          if (!this.isVisible) return;

          this.mobilemenuHide();
        }

        mobilemenuAddCurtain() {
          if (document.querySelector('mobile-menu-curtain')) return;
          // Was `this.innerHTML = '<mobile-menu-curtain></mobile-menu-curtain>' + this.innerHTML`,
          // which serializes and re-parses this element's entire subtree just
          // to prepend one empty marker element - forcing a huge style
          // recalculation (and needlessly re-constructing any other custom
          // elements nested inside) during connectedCallback(), very early
          // in page load. A real DOM insertion touches only the one new node.
          this.prepend(document.createElement('mobile-menu-curtain'));
        }

        dropdownListEventClick(event) {
          if (!event.target.closest(this.dropdownListTarget)) return false;

          let dropdownListEl = event.target;
          if (dropdownListEl.getAttribute('aria-expanded') == 'false') {
            dropdownListEl.setAttribute('aria-expanded', 'true');
            return true;
          }

          dropdownListEl.setAttribute('aria-expanded', 'false');
          return true;
        }

        dropdownListCollapseAll() {
          // close all expanded dropdown lists
          let expandedDropdownListEls = this.mobilemenuEl.querySelectorAll(this.dropdownExpandedListTarget);

          setTimeout(() => {
            for (var i = 0; i < expandedDropdownListEls.length; i++) {
              expandedDropdownListEls[i].setAttribute('aria-expanded', 'false');
            }
          }, this.transitionTime);
        }

        nextTier(tierEl) {
          if (!tierEl) return;

          tierEl.classList.add(this.isActiveClass);

          this.attachScrollingEventListener();
          this.setBackButton();
          this.dropdownListCollapseAll();
        }

        previousTier() {
          var activeTiers = this.mobilemenuEl.querySelectorAll(this.tierActiveTarget);
          var lastActiveTier = activeTiers[activeTiers.length - 1];

          lastActiveTier.classList.remove(this.isActiveClass);

          this.setBackButton();
          this.dropdownListCollapseAll();
        }

        setBackButton() {
          if (!this.mobilemenuEl) return;

          let backButton = this.mobilemenuEl.querySelector('mobile-menu-button-back');
          if (!backButton) return false;

          if (this.mobilemenuEl.querySelectorAll(this.tierActiveTarget).length == 1) {
            backButton.classList.add(this.isHiddenClass);
          } else {
            backButton.classList.remove(this.isHiddenClass);
          }
          return true;
        }

        backButtonEventClick(event) {
          if (!event.target.closest('mobile-menu [data-mobilemenu="back"]')) return false;

          //this.previousTier();

          return true;
        }

        unsetAllActiveTiers() {
          let activeTierEls = this.mobilemenuEl.querySelectorAll(this.tierActiveTarget);
          let self = this;
          setTimeout(() => {
            for (var i = 0; i < activeTierEls.length; i++) {
              let activeTierEl = activeTierEls[i];
              activeTierEl.classList.remove(self.isActiveClass);
            }
          }, this.transitionTime);
        }

        setFirstTier() {
          let tier1El = this.mobilemenuEl.querySelector('#tier-1-0-0');

          if (!tier1El) return;

          if (tier1El.classList.contains(this.isActiveClass)) {
            this.unsetAllActiveTiers();
            this.dropdownListCollapseAll();
          } else {
            tier1El.classList.add(this.isActiveClass);
            this.attachScrollingEventListener();
          }

          this.setBackButton();
        }

        mobilemenuToggle() {
          if (!this.mobilemenuEl) return;

          if (!this.isVisible) {
            this.mobilemenuShow();
          } else {
            this.mobilemenuHide();
          }
        }

        setMobilemenuAnimationStyle() {
          if (!this.mobilemenuEl) return false;

          this.animationStyle = this.mobilemenuEl.classList.contains('mobilemenu--push-left') ? 'push-left' : this.animationStyle;
          this.animationStyle = this.mobilemenuEl.classList.contains('mobilemenu--push-right') ? 'push-right' : this.animationStyle;
          this.animationStyle = this.mobilemenuEl.classList.contains('mobilemenu--overlay-left') ? 'overlay-left' : this.animationStyle;
          this.animationStyle = this.mobilemenuEl.classList.contains('mobilemenu--overlay-right') ? 'overlay-right' : this.animationStyle;
          this.animationStyle = this.mobilemenuEl.classList.contains('mobilemenu--overlay-bottom') ? 'overlay-bottom' : this.animationStyle;
        }

        isAnimationStylePush() {
          return this.animationStyle === 'push-left' || this.animationStyle === 'push-right';
        }

        setMobilemenu() {
          if (!this.mobilemenuEl) return false;

          if (!this.pageWrapEl) {
            console.log('Fostr MobileMenu: Please add the page wrap.');
            return;
          }

          this.pageWrapEl.classList.add('mobilemenu--' + this.animationStyle);
          this.classList.add('mobilemenu--' + this.animationStyle);

          return true;
        }

        // Event handlers
        tierLinkEventClick(event) {
          if (!event.target.closest(this.linkTarget)) return false;

          if (event.target.tagName === 'A') return;

          let linkEl = event.target;
          if (linkEl.nextElementSibling) return true;

          let nextTierEl = this.mobilemenuEl.querySelector('#' + linkEl.id.replace('-link', ''));
          if (!nextTierEl) return true;

          this.nextTier(nextTierEl);

          return true;
        }

        mobilemenuCloseEventClick(event) {
          if (!event.target.closest(this.mobilemenuCloseTarget)) return false;

          this.mobilemenuHide();
        }

        attachScrollingEventListener() {
          if (!this.mobilemenuEl) return;

          let lastActiveTierEl = this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)')[this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)').length - 1];
          if (!lastActiveTierEl) return;

          let lastActiveTierBodyEl = lastActiveTierEl.querySelector('mobile-menu-tier-body');
          if (!lastActiveTierBodyEl) return;

          lastActiveTierBodyEl.addEventListener(
            'scroll',
            () => {
              if (!lastActiveTierBodyEl) return;

              if (lastActiveTierBodyEl.scrollTop > 0) {
                lastActiveTierEl.classList.add('mobilemenu--scrolling');
              } else {
                lastActiveTierEl.classList.remove('mobilemenu--scrolling');
              }
            },
            {
              passive: true,
            }
          );

          lastActiveTierEl.classList.add('mobilemenu--watchingScroll');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua_shop-the-look"]) return;
  try {
    
  if (!customElements.get('shop-look')) {
    customElements.define('shop-look', class ShopTheLook extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("shop-look");

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
              this.remove();
            }

            if (html.querySelector(".grid__item, .slider__slide")) {
              this.classList.add("shop-look--loaded");
            }

            var shopLookGrid = this.querySelector(".shop-the-look-product-grid");
            var shopLookGridChildren = shopLookGrid?.querySelectorAll(".grid__item");

            var shopLookSlider = this.querySelector("shop-look ul.slider");
            var shopLookSliderChildren = shopLookSlider?.querySelectorAll(".grid__item.slider__slide");

            if (shopLookGridChildren?.length > 0) {
              this.closest(".shop-the-look-container")?.classList.remove("hidden");
            } else {
              this.closest(".shop-the-look-container")?.classList.add("hidden");
            }

            if (shopLookSliderChildren?.length > 0 || Shopify.designMode) {
              this.closest(".carousel")?.classList.remove("hidden");
            } else {
              this.closest(".carousel")?.classList.add("hidden");
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua_usp_banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const banners = document.querySelectorAll(".usp-banner");

    if (!banners.length) return;

    // Small local debounce so this bundle doesn't depend on load order
    // relative to the theme's global.js (which defines its own debounce()).
    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    // Measure every banner's natural (pre-clone) width in one batch, before
    // any banner starts inserting clones below - otherwise banner 2's
    // measurement would be forced right after banner 1's DOM insert.
    const bannerConfigs = Array.from(banners)
      .map((banner) => {
        const wrapper = banner.querySelector(".usp-banner__scroll");
        if (!wrapper) return null;

        const originalItems = Array.from(wrapper.children);
        if (!originalItems.length) return null;

        return {
          wrapper,
          originalItems,
          sliderSpeed: parseFloat(wrapper.dataset.sliderSpeed) > 0 ? parseFloat(wrapper.dataset.sliderSpeed) : 6,
          // Read once, up front, before any clones exist - later reads after
          // the clone-insertion write are avoided by deriving scrollDistance
          // from this value instead of re-measuring scrollWidth.
          naturalWidth: wrapper.scrollWidth || 1,
        };
      })
      .filter(Boolean);

    bannerConfigs.forEach(({ wrapper, originalItems, sliderSpeed, naturalWidth }) => {
      let clonesAdded = false,
        scrollDistance = naturalWidth,
        offsetX = 0,
        lastTimestamp = null,
        rafId = null,
        autoplay = false;

      function updateScrollDistance() {
        // Only reached from the resize handler, where content may genuinely
        // have changed size - re-derive the one-set width from the current
        // (possibly 4x, if clones are present) scrollWidth.
        naturalWidth = (clonesAdded ? wrapper.scrollWidth / 4 : wrapper.scrollWidth) || 1;
        scrollDistance = naturalWidth * 2;
      }

      function toggleClones(add) {
        // Only touch the DOM when clone state is actually changing -
        // toggleClones(true) is called on every mouseleave/pointerup/touchend
        // to resume the slider, so once clones are in place this must be a
        // no-op.
        if (add && !clonesAdded) {
          // Build all three copies in a fragment and insert them in a single
          // write, instead of appending one-by-one across three passes.
          const fragment = document.createDocumentFragment();
          for (let i = 0; i < 3; i++) {
            originalItems.forEach((node) => {
              const clone = node.cloneNode(true);
              clone.classList.add("usp-banner__clone");
              fragment.appendChild(clone);
            });
          }
          wrapper.appendChild(fragment);
          clonesAdded = true;
          // Derived from naturalWidth (measured before this insert) - no
          // layout read needed after the DOM write above.
          scrollDistance = naturalWidth * 2;
        } else if (!add && clonesAdded) {
          wrapper.querySelectorAll(".usp-banner__clone").forEach((clone) => clone.remove());
          clonesAdded = false;
          offsetX = 0;
          lastTimestamp = null;
          wrapper.style.transform = "";
          scrollDistance = naturalWidth;
        }
      }

      function animate(timestamp) {
        if (!autoplay) return;
        if (lastTimestamp === null) lastTimestamp = timestamp;
        const delta = timestamp - lastTimestamp;
        lastTimestamp = timestamp;

        offsetX -= (scrollDistance / (sliderSpeed * 1000)) * delta;
        if (offsetX <= -scrollDistance) offsetX += scrollDistance;

        wrapper.style.transform = `translateX(${offsetX}px)`;
        rafId = requestAnimationFrame(animate);
      }

      function playSlider() {
        toggleClones(true);
        autoplay = true;
        lastTimestamp = null;
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(animate);
      }

      function pauseSlider() {
        autoplay = false;
        cancelAnimationFrame(rafId);
      }

      // Pause/resume on user interaction
      ["touchstart", "mousedown", "pointerdown", "mouseenter"].forEach((evt) => wrapper.addEventListener(evt, pauseSlider, { passive: true }));
      ["touchend", "mouseup", "pointerup", "mouseleave"].forEach((evt) => wrapper.addEventListener(evt, playSlider, { passive: true }));

      // Recalculate and restart on resize (debounced so a resize drag doesn't
      // force a layout read on every single resize event, and deferred a
      // frame so the re-measurement rides along with the browser's own
      // post-resize layout pass instead of forcing one).
      window.addEventListener("resize", debounce(() => {
        if (originalItems.length > 3) {
          requestAnimationFrame(updateScrollDistance);
          playSlider();
        }
      }, 150));

      if (originalItems.length > 3) {
        // No layout read here - playSlider() -> toggleClones(true) derives
        // scrollDistance from the naturalWidth measured up front. Still
        // deferred a frame though: this runs inside the DOMContentLoaded
        // handler, a busy moment where other scripts commonly leave a style
        // recalculation pending - appending 3x this banner's items in one
        // go is enough DOM work to force that pending recalc to flush
        // synchronously. Waiting a frame lets the browser's own render pass
        // clear it first.
        requestAnimationFrame(playSlider);
      } else {
        autoplay = false;
        rafId = requestAnimationFrame(animate);
        cancelAnimationFrame(rafId);
        toggleClones(false);
        wrapper.style.justifyContent = "center";
        wrapper.style.width = "100%";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"]) return;
  try {
    
  if (!customElements.get('video-trigger')) {
    customElements.define('video-trigger', class VideoTrigger extends HTMLElement {
      constructor() {
        super();

        this.video = document.querySelector(this.dataset.video);

        this.addEventListener("click", () => {
          this.playVideo();

          if (this.dataset.hide != null) {
            this.hideContent();
          }
        });
      }

      playVideo() {
        const mediaQuery = window.matchMedia("(min-width: 550px)");

        let video;

        if (mediaQuery.matches) {
          video = this.video.querySelector("[data-desktop-video] video");
        } else {
          video = this.video.querySelector("[data-mobile-video] video");
        }

        if (!video) return;

        if (!this.classList.contains("is-playing")) {
          video.play();
          video.setAttribute("data-paused", "false");
        } else {
          video.pause();
          video.setAttribute("data-paused", "true");
        }

        video.addEventListener("ended", this.toggleState.bind(this));

        this.toggleState();
      }

      toggleState() {
        const playIcon = this.querySelector(".icon-play");
        const pauseIcon = this.querySelector(".icon-pause");

        if (!playIcon && !pauseIcon) return;

        this.classList.toggle("is-playing");

        if (this.classList.contains("is-playing")) {
          pauseIcon.classList.toggle("hidden");
          playIcon.classList.toggle("hidden");
          this.querySelector("b").innerText = window.videoControls.pause;
          this.setAttribute("aria-label", window.videoControls.pause);
        } else {
          pauseIcon.classList.add("hidden");
          playIcon.classList.remove("hidden");
          this.querySelector("b").innerText = window.videoControls.play;
          this.setAttribute("aria-label", window.videoControls.play);
        }
      }

      hideContent() {
        const contentToHide = document.querySelector(this.dataset.hide);
        contentToHide.classList.add("hidden");
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
